// ** React Imports
import { useContext, Fragment, useState, useRef, useEffect } from 'react'
import { Link, useHistory } from 'react-router-dom'

// ** Custom Hooks
import { useSkin } from '@hooks/useSkin'
import useJwt from '@src/auth/jwt/useJwt'
import * as Yup from "yup"
import { Cookies } from 'react-cookie'
// ** Third Party Components
import { useDispatch } from 'react-redux'
import { toast, Slide } from 'react-toastify'
import { useForm, Controller } from 'react-hook-form'
import { Facebook, Twitter, Mail, GitHub, HelpCircle, Coffee, AlertTriangle } from 'react-feather'

import { yupResolver } from "@hookform/resolvers/yup"

// ** Actions
import { handleLogin } from '@store/authentication'

// ** Context
import { AbilityContext } from '@src/utility/context/Can'

// ** Custom Components
import Avatar from '@components/avatar'
import InputPasswordToggle from '@components/input-password-toggle'

// ** Utils
import { getHomeRouteForLoggedInUser } from '@utils'

// ** Reactstrap Imports
import { Row, Col, Form, Input, Label, Alert, Button, CardText, CardTitle, UncontrolledTooltip } from 'reactstrap'

import { login } from '../../../requests/auth'
// ** Styles
import '@styles/react/pages/page-authentication.scss'
import Recaptcha from '../../../@core/recaptcha/Recaptcha'
import ToastError from '../../../utility/components/ToastError'

const ToastContent = ({ name }) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color='success' icon={<Coffee size={12} />} />
        <h6 className='toast-title fw-bold'>Welcome, {name}</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>You have successfully logged in Now you can start to explore. Enjoy!</span>
    </div>
  </Fragment>
)
// const ToastError = (err) => (
//   <Fragment>
//     <div className='toastify-header'>
//       <div className='title-wrapper'>
//         <Avatar size='sm' color='danger' icon={<AlertTriangle size={12} />} />
//         <h6 className='toast-title fw-bold'>An error occurred</h6>
//       </div>
//     </div>
//     <div className='toastify-body'>
//       <span>Please try again later</span>
//     </div>
//   </Fragment>
// )

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Wrong email format")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "Minimum 8 symbols")
    .max(28, "Maximum 50 symbols")
    .required("Password is required")
})

const initialValues = {
  email: "",
  password: ""
}
const Login = () => {
  // ** Hooks
  const { skin } = useSkin()
  const dispatch = useDispatch()
  const history = useHistory()
  const ability = useContext(AbilityContext)

  const cookies = new Cookies()
  const resolver = yupResolver(loginSchema)
  const {
    register,
    control,
    setError,
    handleSubmit,
    formState: { errors },
    getValues
  } = useForm({ resolver, defaultValues: initialValues, shouldFocusError: true, reValidateMode: 'onChange' })

  const illustration = skin === 'dark' ? 'login-v2-dark.svg' : 'login-v2.svg',
    source = require(`@src/assets/images/pages/${illustration}`).default

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false)
  const ref = useRef()
  const onSubmit =(data) => {
    if (ref.current) {
      setIsSubmit(true)
    ref.current.execute()
       
    }
  }
  const verifyRecaptcha = (token) => {
    setRecaptchaToken(token)
  }
  useEffect(() => {
    if (!!recaptchaToken && isSubmit) {
      const email = getValues("email")
      const password = getValues("password")
      login(email, password, recaptchaToken)
        .then(res => {
          const tokenName = process.env.REACT_APP_TOKEN_NAME || "back_office_t"
          const refreshTokenName = process.env.REACT_APP_REFRESH_TOKEN_NAME || "back_office_refresh"
          const token = { ...res.data?.tokens?.access }
          const refreshToken = { ...res.data?.tokens?.refresh }
          const user = { ...res.data?.user }
          const data = {
            id: user?.id,
            firstName: user?.first_name,
            lastName: user?.last_name,
            email: user?.email,
            isEmailVerified: user?.isEmailVerified,
            role: user?.role
          }
          dispatch(handleLogin(data))
          cookies.set(tokenName, token?.token, { path: '/', expires: new Date(token?.expires) || undefined })
          cookies.set(refreshTokenName,refreshToken?.token,{ path: '/', expires: new Date(refreshToken?.expires) || undefined })
          // ability.update(res.data.userData.ability)
          history.push(getHomeRouteForLoggedInUser(data.role))
          toast.success(
            <ToastContent name={`${data.firstName  } ${  data.lastName}` || data.email} />,
            { icon: false, transition: Slide, hideProgressBar: true, autoClose: 2000 }
          )
        })
        .catch(err => {
          toast.warning(
            <ToastError error={err} />,
            { icon: false, transition: Slide, hideProgressBar: true }
          )
          console.log(err)
        })
        .finally(() => {
          setIsSubmit(false)
        })
    }
  }, [recaptchaToken])


  return (
    <div className='auth-wrapper auth-cover'>
      <Row className='auth-inner m-0'>
        {/* <Link className='brand-logo' to='/' onClick={e => e.preventDefault()}>
          <svg viewBox='0 0 139 95' version='1.1' height='28'>
            <defs>
              <linearGradient x1='100%' y1='10.5120544%' x2='50%' y2='89.4879456%' id='linearGradient-1'>
                <stop stopColor='#000000' offset='0%'></stop>
                <stop stopColor='#FFFFFF' offset='100%'></stop>
              </linearGradient>
              <linearGradient x1='64.0437835%' y1='46.3276743%' x2='37.373316%' y2='100%' id='linearGradient-2'>
                <stop stopColor='#EEEEEE' stopOpacity='0' offset='0%'></stop>
                <stop stopColor='#FFFFFF' offset='100%'></stop>
              </linearGradient>
            </defs>
            <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
              <g id='Artboard' transform='translate(-400.000000, -178.000000)'>
                <g id='Group' transform='translate(400.000000, 178.000000)'>
                  <path
                    d='M-5.68434189e-14,2.84217094e-14 L39.1816085,2.84217094e-14 L69.3453773,32.2519224 L101.428699,2.84217094e-14 L138.784583,2.84217094e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L6.71554594,44.4188507 C2.46876683,39.9813776 0.345377275,35.1089553 0.345377275,29.8015838 C0.345377275,24.4942122 0.230251516,14.560351 -5.68434189e-14,2.84217094e-14 Z'
                    id='Path'
                    className='text-primary'
                    style={{ fill: 'currentColor' }}
                  ></path>
                  <path
                    d='M69.3453773,32.2519224 L101.428699,1.42108547e-14 L138.784583,1.42108547e-14 L138.784199,29.8015838 C137.958931,37.3510206 135.784352,42.5567762 132.260463,45.4188507 C128.736573,48.2809251 112.33867,64.5239941 83.0667527,94.1480575 L56.2750821,94.1480575 L32.8435758,70.5039241 L69.3453773,32.2519224 Z'
                    id='Path'
                    fill='url(#linearGradient-1)'
                    opacity='0.2'
                  ></path>
                  <polygon
                    id='Path-2'
                    fill='#000000'
                    opacity='0.049999997'
                    points='69.3922914 32.4202615 32.8435758 70.5039241 54.0490008 16.1851325'
                  ></polygon>
                  <polygon
                    id='Path-2'
                    fill='#000000'
                    opacity='0.099999994'
                    points='69.3922914 32.4202615 32.8435758 70.5039241 58.3683556 20.7402338'
                  ></polygon>
                  <polygon
                    id='Path-3'
                    fill='url(#linearGradient-2)'
                    opacity='0.099999994'
                    points='101.428699 0 83.0667527 94.1480575 130.378721 47.0740288'
                  ></polygon>
                </g>
              </g>
            </g>
          </svg>
          <h2 className='brand-text text-primary ms-1'>Vuexy</h2>
        </Link> */}
        <Col className='d-none d-lg-flex align-items-center p-5' lg='8' sm='12'>
          <div className='w-100 d-lg-flex align-items-center justify-content-center px-5'>
            <img className='img-fluid' src={source} alt='Login Cover' />
          </div>
        </Col>
        <Col className='d-flex align-items-center auth-bg px-2 p-lg-5' lg='4' sm='12'>
          <Col className='px-xl-2 mx-auto' sm='8' md='6' lg='12'>
            <CardTitle tag='h2' className='fw-bold mb-1'>
              Welcome to Neosurf Back Office! 👋
            </CardTitle>
            <CardText className='mb-2'>Please sign-in to your account </CardText>
            {/* <Alert color='primary'>
              <div className='alert-body font-small-2'>
                <p>
                  <small className='me-50'>
                    <span className='fw-bold'>Admin:</span> admin@demo.com | admin
                  </small>
                </p>
                <p>
                  <small className='me-50'>
                    <span className='fw-bold'>Client:</span> client@demo.com | client
                  </small>
                </p>
              </div>
              <HelpCircle
                id='login-tip'
                className='position-absolute'
                size={18}
                style={{ top: '10px', right: '10px' }}
              />
              <UncontrolledTooltip target='login-tip' placement='left'>
                This is just for ACL demo purpose.
              </UncontrolledTooltip>
            </Alert> */}
            <Form className='auth-login-form mt-2' onSubmit={handleSubmit(onSubmit)}>
              <div className='mb-1'>
                <Label className='form-label' for='login-email'>
                  Email
                </Label>
                <Controller


                  name='email'
                  control={control}
                  render={({ field }) => (
                    <Input
                      id='email'
                      {...register("email")}
                      {...field}
                      type='text'
                      // placeholder='john@example.com'
                      invalid={errors.email && true}

                    />

                  )}
                />
                {!!errors.email && <div className='text-danger'>{errors.email.message}</div>}
              </div>

              <div className='mb-1'>
                <div className='d-flex justify-content-between'>
                  <Label className='form-label' for='login-password'>
                    Password
                  </Label>
                  {/* <Link to='/forgot-password'>
                    <small>Forgot Password?</small>
                  </Link> */}
                </div>
                <Controller

                  name='password'
                  control={control}
                  render={({ field }) => {
                   
                    return <InputPasswordToggle id='password' {...register("password")}{...field} className='input-group-merge' invalid={errors.password && true} />
                  }}
                />
                {!!errors.password && <div className='text-danger'>{errors.password.message}</div>}
              </div>
              {/* <div className='form-check mb-1'>
                <Input type='checkbox' id='remember-me' />
                <Label className='form-check-label' for='remember-me'>
                  Remember Me
                </Label>
              </div> */}
              <Button type='submit' color='primary' block>
                Sign in
              </Button>
            </Form>
            {/* <p className='text-center mt-2'>
              <span className='me-25'>New on our platform?</span>
              <Link to='/register'>
                <span>Create an account</span>
              </Link>
            </p> */}
            <div className='divider my-2'>
              {/* <div className='divider-text'>or</div> */}
            </div>
            {/* <div className='auth-footer-btn d-flex justify-content-center'>
              <Button color='facebook'>
                <Facebook size={14} />
              </Button>
              <Button color='twitter'>
                <Twitter size={14} />
              </Button>
              <Button color='google'>
                <Mail size={14} />
              </Button>
              <Button className='me-0' color='github'>
                <GitHub size={14} />
              </Button>
            </div> */}
          </Col>
        </Col>
      </Row>
      <Recaptcha ref={ref} verifyRecaptcha={verifyRecaptcha} actionName="login" />
    </div>
  )
}

export default Login
